import React, { useEffect, useState } from 'react';

import { get, isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import './styles.scss';
import VideoPlayer from '../VideoPlayer';
import ModuleCard from './Components/ModuleCard';
import { Link, useParams, useLocation } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import '../../css/styles.scss';
import LoadingSkeleton from '../LoadingSkeleton';
import { Skeleton } from '@material-ui/lab';

//images

import { fetchRecordingsVideoData } from '../../actions/liveClassRecordingsActions';
import { fetchClassData } from '../../actions/digitalDiscussionActions';
import ScrollToTop from '../ScrollToTop';

const getPage = () => {
  let location = useLocation();
  let pathData = location.pathname.split('/');
  if (pathData.includes('addon-classes')) {
    return 'addon-classes';
  } else if (pathData.includes('cbse-classes')) {
    return 'cbse-classes';
  } else if (pathData.includes('live-class-recordings')) {
    return 'live-class-recordings';
  } else {
    return '';
  }
};

export default function VideoDetails() {
  let { unique } = useParams();
  const pageDetails = getPage();

  // State
  const [moduleCode, setModuleCode] = useState('');
  const [uniqueCode, setUniqueCode] = useState('');
  const [selectedIndex, setselectedIndex] = useState(0);
  const [isFetching, setIsFetching] = useState(false);

  // Redux Store
  const dispatch = useDispatch();
  const loginData = useSelector((state) =>
    get(state, 'loginReducer.data.jwt', {})
  );

  let videoData;
  if (pageDetails === 'live-class-recordings') {
    videoData = useSelector((state) =>
      get(state, 'liveClassRecordingsReducer.liveClassRecordingsPlayer', [])
    );
  } else {
    videoData = useSelector((state) =>
      get(state, 'digitalDiscussionReducer.classPlayer', [])
    );
  }

  let classTitle, subject;
  if (videoData) {
    classTitle = videoData.ClassTitle;
    subject = videoData.SubjectName;
  }

  if (pageDetails === 'live-class-recordings') {
    useEffect(() => {
      setIsFetching(true);
      if (moduleCode) {
        fetchRecordingsVideoData(
          uniqueCode,
          moduleCode,
          loginData,
          dispatch
        ).then(() => {
          setIsFetching(false);
        });
      } else {
        fetchRecordingsVideoData(unique, moduleCode, loginData, dispatch).then(
          () => {
            setIsFetching(false);
          }
        );
      }
    }, [loginData, unique, moduleCode]);
  } else {
    useEffect(() => {
      if (moduleCode) {
        Object.keys(videoData).length == 0 && setIsFetching(true);
        fetchClassData(uniqueCode, moduleCode, loginData, dispatch).then(() => {
          setIsFetching(false);
        });
      } else {
        setIsFetching(true);
        fetchClassData(unique, moduleCode, loginData, dispatch).then(() => {
          setIsFetching(false);
        });
      }
    }, [loginData, unique, moduleCode]);
  }

  const moduleHandler = (unique, module) => {
    setUniqueCode(unique);
    setModuleCode(module);
  };

  const populateModuleData = () => {
    let whenLoading = [1, 1, 1, 1];
    const moduleData = [];
    const moduleList = get(videoData, 'listClass', []);
    (isFetching ? whenLoading : moduleList).map((data, index) => {
      if (isFetching) {
        moduleData.push(
          <div
            className="module-container "
            key={`${data.UniqueCode} - ${index}`}
          >
            <Skeleton className="module-image" height="130px" />
            <div className="module-content flex-width-auto">
              <Skeleton className="module-subject" />
              <Skeleton className="module-title" />
              <Skeleton className="module-text" />
            </div>
          </div>
        );
      } else {
        moduleData.push(
          <Link
            key={`${data.UniqueCode} - ${index}`}
            to={
              data.ModuleCode === null
                ? '/' + pageDetails + '/' + data.UniqueCode
                : '/' +
                  pageDetails +
                  '/' +
                  data.UniqueCode +
                  '/' +
                  data.ModuleCode
            }
          >
            <ModuleCard
              key={data.UniqueCode}
              subject={subject}
              subjectTitle={classTitle}
              module={data.ModuleNo}
              selected={selectedIndex === index}
              handler={() => {
                setselectedIndex(index);
                moduleHandler(data.UniqueCode, data.ModuleCode);
              }}
            />
          </Link>
        );
      }
    });
    return moduleData;
  };

  const populateClassMaterial = () => {
    let whenLoading = [1, 1, 1, 1];
    const classData = [];
    (isFetching ? whenLoading : get(videoData, 'listNotes', [])).map(
      (data, index) => {
        if (isFetching) {
          classData.push(<Skeleton className="text" key={index} />);
        } else {
          return classData.push(
            <li key={index}>
              <a
                href={data.Value}
                target="_blank"
                rel="noopener noreferrer"
                className="text"
              >
                {data.Text}
              </a>
            </li>
          );
        }
      }
    );
    return classData;
  };
  const url = getPage();

  return (
    <React.Fragment>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md>
          <div className="video-container">
            <ScrollToTop />
            <Link to={`/${url}`} className="back-btn">
              <ArrowBackIcon /> Back
            </Link>
            <div className="video-header">
              <div className="flex-row flex-space-between">
                {isFetching ? (
                  <Skeleton variant="text" width={200} />
                ) : (
                  <div className="class-text">{subject}</div>
                )}
              </div>
              <div className="video-header-title">
                {isFetching ? (
                  <Skeleton variant="text" width={200} />
                ) : (
                  <h3 className="topic-text">{classTitle}</h3>
                )}
              </div>
            </div>
            {isFetching ? (
              <LoadingSkeleton type="image" height="400px" />
            ) : (
              <div
                className={`video-player ${
                  !isEmpty(videoData) &&
                  get(videoData, 'listClass', []).length > 1
                    ? ''
                    : 'center'
                }`}
              >
                <VideoPlayer source={videoData.ClassURL} autoPlay={false} />
              </div>
            )}
          </div>

          <div className="info-text">
            <span className="imp-text">Important:</span>
            Above video classes are copyrighted and copyright of these classes
            is reserved with ALLEN. Capturing, downloading and sharing of these
            classes is a criminal and punishable offense. All viewers are
            advised to refrain in involving any such activity.
          </div>
        </Grid>
        {get(videoData, 'listClass', []).length > 1 && (
          <Grid item xs={12} sm={12} md={4}>     
              <div className="video-right-panel">
                <PerfectScrollbar>
                {!isEmpty(videoData) &&
                  videoData.listClass &&
                  populateModuleData()}
                </PerfectScrollbar>
              </div>    
          </Grid>
        )}
      </Grid>

      {!isEmpty(videoData) && !isEmpty(videoData.listNotes) && (
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={8}>
            <div className="video-homework mt-30">
              <h3 className="title-heading">Class Homework</h3>
              <ul className="homework-data">{populateClassMaterial()}</ul>
            </div>
          </Grid>
        </Grid>
      )}
    </React.Fragment>
  );
}
